export function addSquareBorder(
  worksheet,
  startCell,
  endCell,
  innerStartCell = null,
  innerEndCell = null,
  outerBorder = "thick",
) {
  // Parse the start and end cell references
  const startRow = worksheet.getCell(startCell).row;
  const startCol = worksheet.getCell(startCell).col;
  const endRow = worksheet.getCell(endCell).row;
  const endCol = worksheet.getCell(endCell).col;

  let innerStartRow;
  let innerStartCol;
  let innerEndRow;
  let innerEndCol;

  if (innerStartCell && innerEndCell) {
    innerStartRow = worksheet.getCell(innerStartCell).row;
    innerStartCol = worksheet.getCell(innerStartCell).col;
    innerEndRow = worksheet.getCell(innerEndCell).row;
    innerEndCol = worksheet.getCell(innerEndCell).col;
  }

  // Loop through the range and apply borders
  for (let row = startRow; row <= endRow; row++) {
    for (let col = startCol; col <= endCol; col++) {
      const cell = worksheet.getCell(row, col);

      // Apply borders based on cell position
      cell.border = {
        top:
          row === startRow
            ? { style: outerBorder }
            : innerStartRow && row >= innerStartRow
              ? { style: "thin" }
              : undefined,
        bottom:
          row === endRow
            ? { style: outerBorder }
            : innerEndRow && row <= innerEndRow
              ? { style: "thin" }
              : undefined,
        left:
          col === startCol
            ? { style: outerBorder }
            : innerStartCol && col >= innerStartCol && col <= innerEndCol
              ? { style: "thin" }
              : undefined,

        right:
          col === endCol
            ? { style: outerBorder }
            : innerEndCol && col <= innerEndCol
              ? { style: "thin" }
              : undefined,
      };
    }
  }
}
